import React from "react";
import { TwitterTweetEmbed } from "react-twitter-embed";
import { SiMedium } from "react-icons/si";
import { AiOutlineTwitter } from "react-icons/ai";
import { ImBlog } from "react-icons/im";
import SectionHead from "../components/common/SectionHead";
import MediaCard from "../components/common/MediaCard";
import { articles, tweetIds, socials } from "../data/content";

const TWEET_COLUMNS = 3;

/* Deal the tweets round-robin so the three columns end up a similar height. */
function intoColumns(ids, count) {
  const columns = Array.from({ length: count }, () => []);
  ids.forEach((id, index) => columns[index % count].push(id));
  return columns;
}

function Writing() {
  return (
    <div className="page">
      <div className="container">
        <SectionHead
          as="h1"
          eyebrow="Writing"
          title="My Recent Blogs and Tweets"
        />

        <section className="writing__block">
          <div className="writing__head">
            <h2>Blogs</h2>
            <a
              href={socials.medium.url}
              className="btn btn--ghost btn--sm"
              target="_blank"
              rel="noopener noreferrer"
            >
              <SiMedium /> Follow me on Medium
            </a>
          </div>

          <div className="card-grid card-grid--wide">
            {articles.map((article) => (
              <MediaCard
                key={article.title}
                image={article.image}
                kicker="Medium"
                title={article.title}
                description={article.description}
                links={[
                  { href: article.url, label: "Read Blog", Icon: ImBlog },
                ]}
              />
            ))}
          </div>
        </section>

        <section className="writing__block">
          <div className="writing__head">
            <h2>Tweets</h2>
            <a
              href={socials.twitter.url}
              className="btn btn--ghost btn--sm"
              target="_blank"
              rel="noopener noreferrer"
            >
              <AiOutlineTwitter /> Follow me on twitter
            </a>
          </div>

          <div className="tweets">
            {intoColumns(tweetIds, TWEET_COLUMNS).map((column, index) => (
              <div className="tweets__column" key={index}>
                {column.map((id) => (
                  <TwitterTweetEmbed
                    key={id}
                    tweetId={id}
                    options={{ theme: "dark", conversation: "none" }}
                    placeholder={<div className="tweet-skeleton" />}
                  />
                ))}
              </div>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
}

export default Writing;
